import React from 'react';
import './Sidebar.css';

const fieldTypes = [
  { type: 'company', label: 'Company Select' },
  { type: 'companydirectors', label: 'Edit Company Director Details' },
  { type: 'companydirectorselect', label: 'Select Company Director' },
  { type: 'companydirectorsselect', label: 'Select Company Director(s)' },
  { type: 'address', label: 'Address Block' },
  { type: 'bankaccounts', label: 'Bank Details' },
  { type: 'vehicles', label: 'Vehicles' },
  { type: 'officers_and_pscs', label: 'Engagement Resolution List' },
  { type: 'email', label: 'Email' },
  { type: 'postcode', label: 'Postcode' },
  { type: 'text', label: 'Text Input' },
  { type: 'textarea', label: 'Textarea' },
  { type: 'number', label: 'Number' },
  { type: 'date', label: 'Date' },
  { type: 'select', label: 'Select' },
  { type: 'checkbox', label: 'Checkbox' },
  { type: 'radio', label: 'Radio Group' },
  { type: 'yesno', label: 'Yes or No'},
  { type: 'group', label: 'Control Group' },
  { type: 'heading', label: 'Heading (H1-H6)' },
  { type: 'styledText', label: 'Styled Text' },
  { type: 'htmltemplateeditor', label: 'HTML Template Editor' }
];

const Sidebar = ({ onAddField, fields, onEditHeader, onEditFooter }) => {


  const handleClick = (field) => {

    const defaultField = {
        type: field.type, // use only the string you expect
        name: `${field.type}-${Date.now()}`,
        label: `New ${field.type}`,
        colSpan:1 ,
        required: false,
        textCase: 'none',
        addresstype: '',
        showRequiredIndicator: true,
        options: field.type === 'select' || field.type === 'radio' ? [
          { label: 'Option 1', value: 'option1' },
          { label: 'Option 2', value: 'option2' }
        ] : undefined
      };
    onAddField(defaultField);
  };

  const checkFieldExists = (fieldtype) => {
    console.log(fields)
    if(fieldtype !== 'companydirectors')
      return false;
    const srch = (fields??[]).find(item => item.type === fieldtype)
    if( srch ) return true
    return false;
  }

  return (
    <div className="sidebar">
      <div className="sidebar-section">
        <h3>Form Header / Footer</h3>
        <button onClick={onEditHeader} className="header-footer-btn">
          📄 Edit Header
        </button>
        <button onClick={onEditFooter} className="header-footer-btn">
          📄 Edit Footer
        </button>
      </div>
      <h3>Add Field</h3>
      {fieldTypes.map((field) => (
        <button key={field.type} onClick={() => handleClick(field)} disabled={checkFieldExists(field.type)}>
          ➕ {field.label}
        </button>
      ))}
    </div>
  );
};

export default Sidebar;
